<template>
  <div class="container">
    <div class="titulo text-center">
      <h2><strong>Autos</strong></h2>
    </div>

    <div class="d-flex justify-content-between mb-3">
      <input
        v-model="searchQuery"
        type="text"
        class="form-control w-25"
        placeholder="Buscar"
      />
    </div>

    <div class="table-container">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Color</th>
            <th>Num. placa</th>
            <th>Año</th>
            <th>Tipo</th>
            <th>Capacidad Máxima</th>
            <th>Disponibilidad</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="auto in paginatedAutos" :key="auto.Id_auto">
            <td>{{ auto.Id_auto }}</td>
            <td>{{ auto.Marca }}</td>
            <td>{{ auto.Modelo }}</td>
            <td>{{ auto.Color }}</td>
            <td>{{ auto.Matricula }}</td>
            <td>{{ auto.Año }}</td>
            <td>{{ auto.Tipo }}</td>
            <td>{{ auto.Capacidad_maxima }}</td>
            <td>{{ auto.Disponibilidad_auto }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lista_autos: [], // Cambiar a 'lista_autos' en lugar de 'lista_conductores'
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredAutos() {
      // Cambiar a 'filteredAutos'
      return this.lista_autos.filter((auto) => {
        // Cambiar a 'auto'
        const searchString = `${auto.Id_auto} ${auto.Modelo} ${auto.Marca} ${auto.Año} ${auto.Color} ${auto.Disponibilidad_auto}`.toLowerCase();
        return searchString.includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedAutos() {
      // Cambiar a 'paginatedAutos'
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredAutos.slice(startIndex, endIndex); // Cambiar a 'filteredAutos'
    },
    totalPages() {
      return Math.ceil(this.filteredAutos.length / this.itemsPerPage); // Cambiar a 'filteredAutos'
    },
  },
  methods: {
    getAutos() {
      // Cambiar a 'getAutos'
      fetch(this.$backendUrl+ "/index.php/autos/lista_completa")
        .then((response) => response.json())
        .then((data) => {
          this.lista_autos = data; // Cambiar a 'lista_autos'
        });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.getAutos(); // Cambiar a 'getAutos'
  },
};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
  margin-bottom: 20px;
  text-align: center;
}

.table {
  width: 100%;
}

.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349; /* Fondo rosa */
  color: white;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 15px;
  padding: 15px 10px;
  margin: 5px 0 10px 0; /* Espacio superior e inferior */
}
</style>
